import { Decimal } from 'decimal.js';

export function setDecimals(value: number, round: number = 2): number {
    if (!value) {
        return 0;
    }

    return new Decimal(value).toDecimalPlaces(round, Decimal.ROUND_HALF_EVEN).toNumber();
}